angular.module('gym.components').directive('contactAttendance', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/attendance/contact_attendance.html.slim'),
    scope: {
      gym: '=',
      contact: '=',
      attendanceForm: '=',
      isVisible: '=',
      attendanceTab: '=',
      setTab: '&',
      reloadContact: '&',
      addBooking: '&',
      bookFriend: '&'
    },
    controller: ["$scope", "$rootScope", "$window", "$http", "$state", "$modal", "$timeout", "flash", "ngTableParams", "LateCancellationService", "EmploymentService", "AdminUserService", "EventService", "Contacts", "MakeUpClasses", "MessageService", function($scope, $rootScope, $window, $http, $state, $modal, $timeout, flash, ngTableParams, LateCancellationService, EmploymentService, AdminUserService, EventService, Contacts, MakeUpClasses, MessageService) {
      var contact, loadFutureBookings, loadMakeUpClasses, loadWaitlist, moreMakeUpClassesAvailable, moreResultsAvailable, reloadBookings;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.adminHasPermission = AdminUserService.has;
      contact = $scope.contact;
      $scope.bookingFilters = {};
      $scope.bookings = [];
      $scope.pastBookings = [];
      $scope.makeUpClassesFilters = {
        'filters[contact_id]': $scope.contact.id
      };
      $scope.isMa = $scope.gym.is_martial_arts;
      $scope.currency = $scope.gym.currency_symbol;
      $rootScope.$on('contact:make_up_classes:reload', function() {
        return $scope.loadMakeUpClasses();
      });
      $scope.$watch('isVisible', function(visible) {
        if (visible) {
          if ($scope.contact.on_waitlist) {
            loadWaitlist();
          }
          if (!$scope.isNonAttending()) {
            return loadFutureBookings();
          }
        }
      });
      loadMakeUpClasses = function(page) {
        var params;
        $scope.makeUpClassesLoading = true;
        params = angular.extend({}, {
          page: page
        }, $scope.makeUpClassesFilters);
        return MakeUpClasses.getList(params).then(function(makeUpClasses) {
          var result;
          if (page > 1) {
            result = $scope.makeUpClasses.concat(makeUpClasses);
            result.meta = makeUpClasses.meta;
          } else {
            result = makeUpClasses;
          }
          $scope.makeUpClasses = result;
          return $scope.makeUpClassesLoading = false;
        });
      };
      $scope.loadMakeUpClasses = function() {
        return loadMakeUpClasses(1);
      };
      moreMakeUpClassesAvailable = function() {
        var makeUpClasses;
        makeUpClasses = $scope.makeUpClasses;
        return !makeUpClasses || (makeUpClasses.length && makeUpClasses.length < makeUpClasses.meta.total);
      };
      $scope.loaMoredMakeUpClasses = _.throttle((function() {
        var page;
        if (!$scope.makeUpClassesLoading && moreMakeUpClassesAvailable()) {
          page = $scope.makeUpClasses ? $scope.makeUpClasses.meta.page + 1 : 1;
          return loadMakeUpClasses(page);
        }
      }), 500);
      $scope.deleteMakeUpClass = function(makeUpClass) {
        if ($window.confirm('Are you sure you want to remove this make-up class?')) {
          return makeUpClass.remove().then(function() {
            return $scope.loadMakeUpClasses();
          });
        }
      };
      $scope.showEvent = function(booking) {
        return EventService.showAttendees(booking.event, {
          showCalendarLink: true
        });
      };
      $scope.editMakeUpClass = function(makeUpClass) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/components/membership/membership_make_up_modal.html.slim'),
          resolve: {
            membership: function() {
              return {
                id: makeUpClass.membership_id,
                label: makeUpClass.membership_name,
                expiration_date: makeUpClass.membership_expiration_date
              };
            },
            makeUpClass: function() {
              return makeUpClass;
            },
            contact: function() {
              return $scope.contact;
            }
          },
          controller: 'MembershipMakeUpClassModalCtrl'
        });
        return modalInstance.result.then(function() {
          return $scope.loadMakeUpClasses();
        });
      };
      $scope.setAttendanceTab = function(tab) {
        $scope.setTab({
          tab: tab
        });
        if (tab === 'make_up_classes') {
          return $scope.loadMakeUpClasses();
        }
      };
      loadFutureBookings = function(page) {
        $scope.bookingsMode = 'future';
        $scope.isLoading = true;
        return contact.all('bookings').all('future_bookings').getList({
          page: page
        }).then(function(bookings) {
          var result;
          if (page > 1) {
            result = $scope.bookings.concat(bookings);
            result.meta = bookings.meta;
          } else {
            result = bookings;
          }
          $scope.bookings = result;
          return $scope.isLoading = false;
        });
      };
      $scope.generalAttendanceTable = new ngTableParams({
        page: 1,
        count: 10
      }, {
        counts: [],
        total: 0,
        getData: function($defer, $params) {
          return contact.all('general_attendances').getList($params.url()).then(function(data) {
            $params.total(data.meta.total);
            $scope.generalAttendance = data;
            return $defer.resolve(data);
          });
        }
      });
      $scope.generalAttendanceRange = function() {
        var from, page, to;
        if (!$scope.generalAttendance) {
          return;
        }
        if (!$scope.generalAttendance.length) {
          return 0;
        }
        page = $scope.generalAttendance.meta.page;
        from = ((page - 1) * 10) + 1;
        to = ((page - 1) * 10) + $scope.generalAttendance.length;
        return `${from} - ${to}`;
      };
      $scope.updateAttendance = function(booking, previousValue) {
        var url;
        url = `gyms/${$rootScope.gym.id}/calendar/events/${booking.event_id}`;
        return $http.get(url).then(function(response) {
          var event;
          event = response.data;
          return EventService.confirmUpdateAttendance({
            event: event,
            booking: booking,
            studentName: $scope.contact.name,
            previousValue: previousValue,
            reloadAttendance: $scope.reloadAttendance
          });
        });
      };
      $scope.addAppointment = function() {
        return EventService.addAppointment({
          contact_id: contact.id
        });
      };
      $scope.reloadAttendance = function() {
        $scope.editableSectionName = false;
        return $scope.reloadContact();
      };
      $scope.deleteAttendance = function(attendance) {
        if ($window.confirm('Are you sure you want to delete this attendance?')) {
          return attendance.remove().then(function() {
            $scope.reloadAttendance();
            return $scope.generalAttendanceTable.reload();
          });
        }
      };
      $scope.getExportUrl = function() {
        return `${contact.getRestangularUrl()}/contact_attendances.csv`;
      };
      $scope.isNonAttending = function() {
        return $scope.contact.type === 'non_attending_contact';
      };
      moreResultsAvailable = function() {
        var bookings;
        bookings = $scope.bookings;
        return $scope.bookingsMode !== 'filtered' && bookings.length && bookings.length < bookings.meta.total;
      };
      $scope.loadFutureBookings = _.throttle((function() {
        if (!$scope.isLoading && moreResultsAvailable()) {
          return loadFutureBookings($scope.bookings.meta.page + 1);
        }
      }), 500);
      $scope.showPastBookings = function() {
        $scope.bookingsMode = 'past';
        return contact.all('bookings').all('past_bookings').getList().then(function(bookings) {
          return $scope.pastBookings = bookings.plain();
        });
      };
      $scope.hidePastBookings = function() {
        return $scope.bookingsMode = 'future';
      };
      $scope.attendanceFilterOptions = [
        {
          id: -1,
          label: "From other Members"
        }
      ].concat($scope.contact.memberships);
      $scope.loadBookings = function() {
        var params;
        params = {
          'filters[starts_before]': $scope.bookingFilters.starts_before,
          'filters[starts_after]': $scope.bookingFilters.starts_after,
          'filters[membership_id]': $scope.bookingFilters.membership_id,
          count: 1000
        };
        return contact.all('bookings').getList(params).then(function(bookings) {
          return $scope.bookings = bookings.plain();
        });
      };
      $scope.filterBookings = function() {
        return $timeout(function() {
          $scope.bookingsMode = 'filtered';
          return $scope.loadBookings();
        });
      };
      $scope.clearAttendanceFilters = function() {
        $scope.bookingFilters = {};
        return loadFutureBookings(1);
      };
      $scope.showInfo = function(booking) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/gyms/calendar/events/booking_info_modal.html.slim'),
          resolve: {
            booking: function() {
              return booking;
            }
          },
          controller: 'BookingInfoCtrl'
        });
      };
      $scope.removeBooking = function(booking, form) {
        var modalInstance;
        modalInstance = booking.restrict_cancellations && !booking.cancellable && booking.allow_late_cancellations ? LateCancellationService.cancel(booking) : $modal.open({
          template: require('templates/gyms/calendar/cancel_bookings_modal.html.slim'),
          resolve: {
            booking: function() {
              return booking;
            },
            contact: function() {
              return contact;
            },
            fromContactProfile: function() {
              return true;
            }
          },
          controller: 'CancelBookingsCtrl'
        });
        return modalInstance.result.then(function() {
          $scope.reloadAttendance();
          return reloadBookings();
        });
      };
      reloadBookings = function() {
        if ($scope.bookingsMode === 'filtered') {
          return $scope.loadBookings();
        } else {
          loadFutureBookings();
          if ($scope.bookingsMode === 'past') {
            return $scope.showPastBookings();
          }
        }
      };
      $scope.goToCustomFields = function() {
        return $state.go('gym.form-library');
      };
      $rootScope.$on('calendar:updated', function() {
        return $scope.clearAttendanceFilters();
      });
      $rootScope.$on('contact:attendance:updated', function(event, contactId) {
        if (contact.id === contactId) {
          $scope.reloadContact();
          return $scope.generalAttendanceTable.reload();
        }
      });
      $scope.deleteWaitlist = function(waitlist) {
        return EventService.removeFromWaitlist(waitlist).then(function() {
          return loadWaitlist();
        });
      };
      $scope.isBookedForFriend = function(booking) {
        return booking.membership_taken_from_contact_id && booking.membership_taken_from_contact_id !== booking.student_id;
      };
      return loadWaitlist = function() {
        return contact.all('waitlist_attendees').getList().then(function(waitlist) {
          return $scope.waitlistItems = waitlist;
        });
      };
    }]
  };
});
